module.exports = __webpack_public_path__ + "media/base/customer_small-82edb36b.svg";